import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Table, Button, Spinner } from "reactstrap";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { ToWords } from 'to-words';

// 🔥 Machan, assets folder la irundhu logo eduthutaen
import logo from "../../Assets/images/logo-1.png"; 

const InvoiceView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState(null);

    const toWords = new ToWords({
        localeCode: 'en-IN',
        converterOptions: { currency: true, ignoreDecimal: false, ignoreZeroCurrency: false }
    });

    useEffect(() => {
        fetchInvoiceDetails();
    }, [id]);

    const fetchInvoiceDetails = async () => {
        dispatch(loadingTrue());
        try {
            const res = await Handler({ method: "GET", url: `/invoice/view.php?id=${id}` });
            if (res?.success) {
                setData(res.data);
            } else {
                toast.error(res?.message || "Invoice not found");
            }
        } catch (err) {
            toast.error("Server error occurred");
        } finally {
            dispatch(loadingFalse());
        }
    };

    if (!data) return <div className="p-5 text-center"><Spinner color="danger" /></div>;

    // 🔥 Machan, sub_client extra-va destruct pannirukaen addon-kaga
    const { invoice, client, sub_client, lorry, items, summary } = data;

    // 🔥 Exact Greenish-Grey colors from your PDF
    const primaryColor = "#2e4a3d"; 
    const borderColor = "#d1d5db";

    return (
        <Container className="py-4 px-2 bg-light min-vh-100">
            {/* Action Bar */}
            <div className="d-flex justify-content-between align-items-center mb-4 no-print">
                <Button color="secondary" outline size="sm" onClick={() => navigate(-1)} className="rounded-pill">
                    <i className="bx bx-left-arrow-alt"></i> Back
                </Button>
                {/* <Button color="danger" size="sm" onClick={() => window.print()} className="rounded-pill px-4 shadow-sm">
                    <i className="bx bx-printer"></i> Print / Download
                </Button> */}
            </div>

            {/* Main Invoice Document */}
            <Card className="border-0 mx-auto shadow-lg" style={{ width: "210mm", minHeight: "297mm", borderRadius: "0", color: "#000", fontFamily: "'Inter', sans-serif" }}>
                <CardBody className="p-5">
                    
                    {/* Header Section */}
                    <div className="d-flex justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                            <img src={logo} alt="Logo" style={{ height: "80px", marginRight: "20px" }} />
                            <div>
                                <h1 className="fw-bold m-0" style={{ color: primaryColor, fontSize: '32px', letterSpacing: '1px' }}>MUTHIAH COTTON MILL</h1>
                                <p className="m-0 fw-bold small text-uppercase" style={{ color: "#555" }}>Cotton & Cotton Seeds Merchant</p>
                                <p className="m-0 small fw-bold">GSTIN: 33QDTPS4652E1ZT</p>
                            </div>
                        </div>
                        <div className="text-end">
                            <h4 className="fw-bold m-0" style={{ color: "#9ca3af", letterSpacing: "1px" }}>TAX INVOICE</h4>
                            <h5 className="fw-bold m-0 mt-1">Invoice No: {invoice.invoice_no}</h5>
                            <p className="m-0 small">Date: {dayjs(invoice.invoice_date).format("DD-MM-YYYY")}</p>
                            <p className="m-0 small">HSN Code: {invoice.hsn_code || '5201'}</p>
                        </div>
                    </div>

                    {/* Address Section */}
                    <Row className="mb-4 small border-top border-bottom py-3" style={{ borderColor: `${borderColor} !important` }}>
                        <Col xs={6} className="border-end" style={{ borderColor: borderColor }}>
                            <h6 className="fw-bold mb-1 text-uppercase" style={{ color: primaryColor, fontSize: "12px" }}>Office:</h6>
                            <p className="mb-0 text-muted">42/1, AMBIGAPATHI STREET, KARAIKKUDI,</p>
                            <p className="mb-0 text-muted">SIVAGANGA, TAMIL NADU 630001</p>
                            <p className="mb-0 text-muted">Mobile: 9659285595 | Email: krmuthiahmill@gmail.com</p>
                        </Col>
                        <Col xs={6} className="ps-4">
                            <h6 className="fw-bold mb-1 text-uppercase" style={{ color: primaryColor, fontSize: "12px" }}>Factory:</h6>
                            <p className="mb-0 text-muted">607/6B2, MUTHIAH COTTON MILL, SH 34A,</p>
                            <p className="mb-0 text-muted">SALAIGRAMAM, SIVAGANGA, TAMIL NADU 630702</p>
                            <p className="mb-0 text-muted">Mobile: 9659285595 | Email: krmuthiahmill@gmail.com</p>
                        </Col>
                    </Row>

                    {/* Info Blocks */}
                    <Row className="mb-4 g-4">
                        <Col xs={7}>
                            <div className="border rounded p-0 overflow-hidden" style={{ borderColor: borderColor }}>
                                <div className="bg-light px-3 py-1 border-bottom fw-bold text-uppercase small" style={{ fontSize: "11px", letterSpacing: "1px" }}>Billed To</div>
                                <div className="p-3">
                                    <h5 className="fw-bold mb-1" style={{ color: "#111" }}>{client.name}</h5>
                                    <p className="mb-1 small text-muted text-capitalize">{client.address}</p>
                                    <p className="mb-1 fw-bold small">GSTIN: {client.gstin}</p>
                                    
                                    {/* 🔥 Add-on: Sub Client Details (Branch) */}
                                    {sub_client?.name && (
                                        <div className="mt-3 pt-2 border-top border-light">
                                            <small className="text-uppercase fw-bold text-muted d-block mb-1" style={{ fontSize: "9px" }}>Consignee / Branch:</small>
                                            <h6 className="fw-bold mb-1" style={{ fontSize: "14px" }}>{sub_client.name}</h6>
                                            <p className="mb-0 small text-muted text-capitalize">{sub_client.address}</p>
                                            {sub_client.gstin && <p className="mb-0 small fw-bold">GSTIN: {sub_client.gstin}</p>}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col xs={5}>
                            <div className="border rounded p-0 overflow-hidden" style={{ borderColor: borderColor }}>
                                <div className="bg-light px-3 py-1 border-bottom fw-bold text-uppercase small" style={{ fontSize: "11px", letterSpacing: "1px" }}>Transport Details</div>
                                <div className="p-3 small">
                                    <div className="d-flex mb-1"><span style={{ width: "80px" }}>Lorry No</span><span>: <strong>{lorry.lorry_number}</strong></span></div>
                                    <div className="d-flex mb-1"><span style={{ width: "80px" }}>Driver</span><span>: {lorry.driver_name}</span></div>
                                    <div className="d-flex"><span style={{ width: "80px" }}>Mobile</span><span>: {lorry.driver_phone}</span></div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Items Table */}
                    <Table bordered responsive className="mb-4">
                        <thead style={{ backgroundColor: primaryColor, color: "#fff" }}>
                            <tr className="small text-uppercase fw-bold text-center border-0">
                                <th className="border-0" style={{ width: "5%" }}>#</th>
                                <th className="border-0 text-start">Description of Goods</th>
                                <th className="border-0" style={{ width: "12%" }}>Bags</th>
                                <th className="border-0" style={{ width: "18%" }}>Quintal</th>
                                <th className="border-0 text-end pe-4" style={{ width: "22%" }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {items.map((item, index) => (
                                <tr key={index}>
                                    <td className="py-3 border-start-0 border-end-0 border-bottom text-muted small">{index + 1}</td>
                                    <td className="text-start py-3 border-start-0 border-end-0 border-bottom fw-bold text-uppercase" style={{ color: "#374151" }}>{item.product_name}</td>
                                    <td className="py-3 border-start-0 border-end-0 border-bottom">{item.quantity.bags}</td>
                                    <td className="py-3 border-start-0 border-end-0 border-bottom">{item.quantity.quintal} Q</td>
                                    <td className="text-end py-3 pe-4 border-start-0 border-end-0 border-bottom fw-bold">₹ {item.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                </tr>
                            ))}
                            {/* Filling space to match PDF look */}
                            <tr style={{ height: "120px" }}><td colSpan={5} className="border-0"></td></tr>
                        </tbody>
                    </Table>

                    {/* Footer Summary */}
                    <Row className="g-4">
                        <Col xs={7}>
                            <div className="mb-4">
                                <small className="fw-bold text-uppercase d-block mb-1" style={{ color: primaryColor, fontSize: "11px" }}>Amount in Words:</small>
                                <p className="fw-bold small mb-2 text-uppercase font-italic" style={{ borderBottom: `1px dashed ${borderColor}`, paddingBottom: "10px" }}>
                                    {toWords.convert(summary.total_amount)} ONLY
                                </p>
                            </div>

                            <div className="mt-4">
                                <h6 className="fw-bold small text-decoration-underline mb-2">Terms and Conditions:</h6>
                                <ul className="ps-3 mb-0 text-muted" style={{ fontSize: '10px', lineHeight: "1.6" }}>
                                    <li>Interest will be recovered @ 24% P.A on overdue unpaid bills.</li>
                                    <li>Claims within 3 days.</li>
                                    <li>Goods once sold cannot be returned.</li>
                                    <li>Payments at our office.</li>
                                    <li className="text-dark fw-bold mt-2 font-italic">Computer generated document, signature not required.</li>
                                </ul>
                            </div>
                        </Col>
                        
                        <Col xs={5}>
                            <div className="rounded overflow-hidden shadow-sm border" style={{ borderColor: borderColor }}>
                                <Table size="sm" borderless className="mb-0 fw-bold">
                                    <tbody style={{ fontSize: "13px" }}>
                                        <tr className="border-bottom" style={{ borderColor: "#f3f4f6" }}><td className="ps-3 py-2 text-muted">Total Kg</td><td className="text-end pe-3 py-2">{summary.total_kg}</td></tr>
                                        <tr className="border-bottom" style={{ borderColor: "#f3f4f6" }}><td className="ps-3 py-2 text-muted">Sub Total</td><td className="text-end pe-3 py-2">₹ {summary.subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td></tr>
                                        <tr className="border-bottom text-muted" style={{ borderColor: "#f3f4f6", fontSize: "12px" }}><td className="ps-3 py-1">CGST (2.5%)</td><td className="text-end pe-3 py-1">₹ {summary.cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td></tr>
                                        <tr className="border-bottom text-muted" style={{ borderColor: "#f3f4f6", fontSize: "12px" }}><td className="ps-3 py-1">SGST (2.5%)</td><td className="text-end pe-3 py-1">₹ {summary.sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td></tr>
                                        <tr style={{ backgroundColor: primaryColor, color: '#fff' }}>
                                            <td className="ps-3 py-3 text-uppercase" style={{ fontSize: '15px' }}>Grand Total</td>
                                            <td className="text-end pe-3 py-3" style={{ fontSize: '17px' }}>₹ {summary.total_amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>

                    {/* Signature Section */}
                    <div className="mt-5 pt-5 text-end">
                        <div className="d-inline-block text-center">
                            <p className="small fw-bold mb-5 text-uppercase" style={{ color: "#333" }}>For MUTHIAH COTTON MILL</p>
                            <div className="border-top pt-2 px-4 fw-bold small">Authorized Signatory</div>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <style>
                {`
                    @media print {
                        @page { size: A4; margin: 0; }
                        body { background: white !important; -webkit-print-color-adjust: exact !important; }
                        .no-print { display: none !important; }
                        .container { max-width: 100% !important; width: 100% !important; padding: 0 !important; margin: 0 !important; }
                        .card { border: none !important; box-shadow: none !important; width: 100% !important; }
                        .table thead th { background-color: ${primaryColor} !important; color: white !important; }
                    }
                    .table-bordered th, .table-bordered td { border: 1px solid #f3f4f6 !important; }
                `}
            </style>
        </Container>
    );
};

export default InvoiceView;